import React, { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { Col, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import Breadcrumb from "../../Breadcrumb/Breadcrumb";
import { BASEURL, upperCase } from "../../../constant/api";
import useRequest from "../../../hooks/useRequest";

const StepOne = ({
  handleNextStep,
  outletId,
  allStepsData,
  setAllFormData,
  isEdit,
}) => {
  const token = useSelector((state) => state.auth?.token);
  const [loader, setLoader] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [touchedError, setTouchedError] = useState(false);
  const { response: responseSubCategory, request: requestSubCategory } =
    useRequest();

  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
  } = useForm();

  useEffect(() => {
    requestSubCategory("POST", "manageCategory/getCategorys", {
      type: "vendorSubCategory",
    });
  }, []);

  useEffect(() => {
    if (
      responseSubCategory?.status === true ||
      responseSubCategory?.status === "success"
    ) {
      setSubCategories(
        responseSubCategory?.data?.length ? responseSubCategory.data : [],
      );
    }
  }, [responseSubCategory]);

  useEffect(() => {
    if (!allStepsData) {
      return;
    }
    setSelectedSubCategory(allStepsData?.vendorSubCategory || []);
    setValue("outletName", allStepsData?.outletName || "");
    setValue("posName", allStepsData?.posName || "");
    setValue("posId", allStepsData?.posId || "");
    setValue("vendorSubCategory", allStepsData?.vendorSubCategory || []);
  }, [allStepsData, setValue]);

  const onSubmit = async (data) => {
    setLoader(true);
    try {
      const config = token
        ? { headers: { Authorization: `Bearer ${token}` } }
        : undefined;

      await Promise.all([
        axios.post(
          `${BASEURL.PORT}/admin/vendor/updateOutletName`,
          {
            name: data.outletName,
            outletId,
          },
          config,
        ),
        axios.post(
          `${BASEURL.PORT}/admin/vendor/updateOutletPosDetail`,
          {
            outletId,
            posId: data.posId,
            posName: data.posName,
          },
          config,
        ),
      ]);

      setAllFormData((prev) => ({
        ...prev,
        ...data,
        outletId,
      }));
      toast.success("Outlet basic details updated successfully.");
      handleNextStep(2);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to update outlet details.",
      );
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div className="col-md-12">
          <Breadcrumb
            title="Add/Edit Outlet"
            links={[
              { to: "/", name: "Home" },
              { to: "/vendors", name: "Outlets" },
            ]}
          />
        </div>
        <div className="col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>{isEdit ? "Edit Outlet" : "Add Outlet"}</h6>
            </div>
            <div className="ms-panel-body">
              <form
                className="needs-validation"
                onSubmit={handleSubmit(onSubmit)}
                noValidate
              >
                <div className="form-vendor-regi">
                  <div className="form-vendor">
                    <Row>
                      <Col md={12}>
                        <label htmlFor="vendorSubCategory">
                          Select Your Sub-Category
                          <span className="error">*</span>
                        </label>
                        <div className="dropdown-group">
                          <Select
                            isMulti
                            name="vendorSubCategory"
                            options={subCategories.map((item) => ({
                              value: item._id,
                              label: upperCase(item.name),
                            }))}
                            {...register("vendorSubCategory", {
                              required: true,
                            })}
                            value={selectedSubCategory}
                            onChange={(action) => {
                              setSelectedSubCategory(action || []);
                              setValue("vendorSubCategory", action || []);
                              if (action?.length) {
                                setError("vendorSubCategory", "");
                              } else {
                                setError("vendorSubCategory", {
                                  type: "required",
                                });
                              }
                            }}
                            className={`basic-multi-select ${
                              touchedError
                                ? errors.vendorSubCategory
                                  ? "is-invalid"
                                  : "is-valid"
                                : ""
                            }`}
                            classNamePrefix="select"
                          />
                          {errors.vendorSubCategory?.type === "required" && (
                            <div className="invalid-select invalid-feedback">
                              The sub category field is required.
                            </div>
                          )}
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: "20px" }}>
                          <label htmlFor="outletName">
                            Name of the Restaurent/Hotel
                            <span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="outletName"
                              id="outletName"
                              placeholder="Place Name"
                              className={`form-control ${
                                touchedError
                                  ? errors.outletName
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("outletName", { required: true })}
                            />
                            {errors.outletName?.type === "required" && (
                              <div className="invalid-feedback">
                                The name of Restaurent/Hotel field is required.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: "20px" }}>
                          <label htmlFor="posName">
                            POS name<span className="error">*</span>
                          </label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="posName"
                              id="posName"
                              placeholder="POS Name"
                              className={`form-control ${
                                touchedError
                                  ? errors.posName
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("posName", { required: true })}
                            />
                            {errors.posName?.type === "required" && (
                              <div className="invalid-feedback">
                                The POS name field is required.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div style={{ marginTop: "20px" }}>
                          <label htmlFor="posId">POS ID name</label>
                          <div className="input-group">
                            <input
                              type="text"
                              name="posId"
                              id="posId"
                              placeholder="POS ID Name"
                              className={`form-control ${
                                touchedError
                                  ? errors.posId
                                    ? "is-invalid"
                                    : "is-valid"
                                  : ""
                              }`}
                              {...register("posId", { required: false })}
                            />
                            {errors.posId?.type === "required" && (
                              <div className="invalid-feedback">
                                The POS ID name field is required.
                              </div>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                {loader ? (
                  <center>
                    <Spinner
                      animation="border"
                      className="d-flex justify-content-center"
                    />
                  </center>
                ) : (
                  <button
                    className="btn btn-primary"
                    type="submit"
                    onClick={() => setTouchedError(true)}
                  >
                    Next
                  </button>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepOne;
